module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "update-firebase-results-modal"
  }, [_c('div', {
    staticClass: "update-firebase-results-modal__overlay",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-firebase-results-modal__modal"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4L4 12M4 4L12 12",
      "stroke": "#666",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content-modal"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [(_vm.results.success && _vm.results.errorCount === 0) ? _c('svg', {
    staticClass: "icon icon-success",
    attrs: {
      "width": "64",
      "height": "64",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14",
      "stroke": "#10b981",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22 4 12 14.01 9 11.01",
      "stroke": "#10b981",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _c('svg', {
    staticClass: "icon icon-warning",
    attrs: {
      "width": "64",
      "height": "64",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "#f59e0b",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 8v4M12 16h.01",
      "stroke": "#f59e0b",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.results.success && _vm.results.errorCount === 0 ? 'Update Completed' : 'Update Completed with Warnings'))]), _vm._v(" "), _c('div', {
    staticClass: "stats-container"
  }, [_c('div', {
    staticClass: "stat-item stat-success"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.results.updatedCount || 0))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Updated")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item stat-skipped"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.results.skippedCount || 0))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Skipped")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item",
    class: _vm.results.errorCount > 0 ? 'stat-error' : 'stat-neutral'
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.results.errorCount || 0))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Errors")])])]), _vm._v(" "), (_vm.results.errors && _vm.results.errors.length > 0) ? _c('div', {
    staticClass: "errors-container"
  }, [_c('div', {
    staticClass: "errors-title"
  }, [_vm._v("Error Details:")]), _vm._v(" "), _c('div', {
    staticClass: "errors-list"
  }, [_vm._l((_vm.results.errors.slice(0, 5)), function(error, index) {
    return _c('div', {
      key: index,
      staticClass: "error-item"
    }, [_vm._v("\n            " + _vm._s(error) + "\n          ")])
  }), _vm._v(" "), (_vm.results.errors.length > 5) ? _c('div', {
    staticClass: "error-more"
  }, [_vm._v("\n            ... and " + _vm._s(_vm.results.errors.length - 5) + " more errors\n          ")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Close\n        ")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e6d57fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/UpdateFromFirebaseResultsModal.vue
// module id = 1715
// module chunks = 2